import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=auth
  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      });
  }, []);

  const login = async (email, password, captcha) => {
    try {
      const { data } = await api.post("/auth/login", { email, password, challenge_id: captcha?.challenge_id, slider_x: captcha?.slider_x });
      if (data.mfa_required) return { ok: false, mfa: true, pre_token: data.pre_token };
      localStorage.setItem("token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const verifyMfa = async (pre_token, code) => {
    try {
      const { data } = await api.post("/auth/mfa/verify", { pre_token, code });
      localStorage.setItem("token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
    window.location.href = "/login";
  };

  return <AuthContext.Provider value={{ user, login, verifyMfa, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
